import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { AsyncJSMProjectSummaryHorizontalNav } from '@jira/navigation-apps__horizontal-nav-jsm-project-summary/src/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskProjectSummaryRoute } from '@jira/router-routes__servicedesk-project-summary-routes/src/servicedeskProjectSummaryRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import {
	resourceWithCondition,
	safeCloneResource,
} from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { capabilitiesConfigResource } from '@jira/router-resources__viz-platform/src/capabilitiesConfigResource.tsx';
import { dashboardConfigResource } from '@jira/router-resources__viz-platform/src/dashboardConfigResource.tsx';
import { jsmSummarySemanticModelResource } from '@jira/router-resources__viz-platform/src/jsmSummarySemanticModelResource.tsx';
import { ProjectSummarySkeleton } from '@jira/platform__skeletons/src/ui/servicedesk/project-summary/ProjectSummarySkeleton.tsx';
import { getProjectSummaryFilterFieldsResource } from '@jira/router-resources__service-desk-project-summary/src/useGetProjectSummaryFilterFields.tsx';
import {
	summaryPageViewsResource,
	SUMMARY_PAGE_VIEWS_RESOURCE_KEY,
} from '@jira/router-resources__service-desk-project-summary/src/summaryPageViewsResource.tsx';
import { summaryPageConfigResource } from '@jira/router-resources__service-desk-project-summary/src/useSummaryPageConfig.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { projectSummaryPageEntryPoint } from './ui/index.tsx';

export const servicedeskProjectSummaryRouteEntry: Route = createEntry(
	servicedeskProjectSummaryRoute,
	() => ({
		group: 'servicedesk',
		ufoName: 'jsm.project-summary',
		// eslint-disable-next-line no-restricted-syntax
		component: () => null,
		skeleton: ProjectSummarySkeleton,

		navigation: {
			menuId: MenuIdProjects,
			horizontal:
				// eslint-disable-next-line jira/ff/no-preconditioning
				fg('jsm_project_summary_avp') && fg('jsm_project_summary_avp_m1')
					? AsyncJSMProjectSummaryHorizontalNav
					: undefined,
		},

		layout: serviceProjectLayout,

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			getConsolidationStateResource(),
			resourceWithCondition(
				() => !fg('jsm_project_summary_avp'),
				getProjectSummaryFilterFieldsResource(),
			),
			resourceWithCondition(
				() => !__SERVER__ && fg('jsm_project_summary_avp'),
				summaryPageViewsResource,
			),
			resourceWithCondition(
				() => fg('jsm_summary_page_is_reporting_enabled'),
				summaryPageConfigResource,
			),
			// TODO: AVP route resources here
			capabilitiesConfigResource,
			jsmSummarySemanticModelResource,
			resourceWithCondition(
				() => fg('platform_avp_dashboard-resource_jsm-proj-sum'),
				safeCloneResource(dashboardConfigResource, {
					depends: [SUMMARY_PAGE_VIEWS_RESOURCE_KEY],
				}),
			),
		],

		entryPoint: () => projectSummaryPageEntryPoint,

		meta: {
			reporting: {
				id: 'project-summary',
				packageName: toPackageName(APP_NAMES.PROJECT_SUMMARY),
				teamName: 'jsd-shield',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
